/* Little Dumplings theme – Shopify */
(function(){
  'use strict';
  var T=window.THEME||{};
  T.routes=T.routes||{};
  function $(id){return document.getElementById(id)}

  /* Little dumplings as SVG */
  var V=[
    {c:'#FFE1E6',s:'#EDB4BE',hat:1},{c:'#E3F3E9',s:'#A9D3BC',ant:1},{c:'#FFF4CF',s:'#EBD48A',bow:1},
    {c:'#ECE6F8',s:'#C4B7E3',hat:1},{c:'#FFFFFF',s:'#E5CFCF',ant:1},{c:'#FFE6D3',s:'#EBBE9D',bow:1},
    {c:'#DFF0F7',s:'#A7CCE0',hat:1},{c:'#F6E9F3',s:'#DDB9D3',ant:1},{c:'#FFF4CF',s:'#EBD48A',star:1},
    {c:'#E3F3E9',s:'#A9D3BC',holly:1}
  ];
  function dumpling(o){
    var t='#4A363B',x='<svg viewBox="0 0 100 100" aria-hidden="true">';
    if(o.ant)x+='<g fill="none" stroke="#C9A183" stroke-width="3" stroke-linecap="round"><path d="M35 30L29 12M29 12L23 15M32 20L26 21"/><path d="M65 30L71 12M71 12L77 15M68 20L74 21"/></g>';
    x+='<path d="M10 64c0-23 18-40 40-40s40 17 40 40c0 12-9 20-21 20H31c-12 0-21-8-21-20z" fill="'+o.c+'" stroke="'+o.s+'" stroke-width="2.5"/>';
    x+='<path d="M38 30q-3 7 0 13M50 27v16M62 30q3 7 0 13" fill="none" stroke="'+o.s+'" stroke-width="2.5" stroke-linecap="round"/>';
    x+='<circle cx="37" cy="62" r="3.6" fill="'+t+'"/><circle cx="63" cy="62" r="3.6" fill="'+t+'"/>';
    x+='<ellipse cx="28" cy="70" rx="5.5" ry="3.4" fill="#FF9FAE" opacity=".55"/><ellipse cx="72" cy="70" rx="5.5" ry="3.4" fill="#FF9FAE" opacity=".55"/>';
    x+='<path d="M45 68q5 4.5 10 0" fill="none" stroke="'+t+'" stroke-width="2.4" stroke-linecap="round"/>';
    if(o.hat)x+='<path d="M27 32C30 12 52 6 68 16c5 4 6 10 6 16z" fill="#D0576A"/><rect x="24" y="29" width="52" height="9" rx="4.5" fill="#fff" stroke="'+o.s+'" stroke-width="1.5"/><circle cx="68" cy="13" r="5.5" fill="#fff" stroke="'+o.s+'" stroke-width="1.5"/>';
    if(o.bow)x+='<path d="M50 25L37 17V33zM50 25L63 17V33z" fill="#D0576A"/><circle cx="50" cy="25" r="4" fill="#B7465A"/>';
    if(o.star)x+='<path d="M50 6l4 9 9.500 1-7.200 6.400 2.200 9.400L50 26.800 41.500 31.800l2.200-9.400L36.500 16l9.500-1z" fill="#F2C063" stroke="#E0A93E" stroke-width="1.5" stroke-linejoin="round"/>';
    if(o.holly)x+='<path d="M50 26c-6-10-16-8-18-4 4 8 14 8 18 4zM50 26c6-10 16-8 18-4-4 8-14 8-18 4z" fill="#5E9C82" stroke="#487D66" stroke-width="1.5"/><circle cx="50" cy="26" r="3.6" fill="#D0576A"/>';
    return x+'</svg>';
  }
  function fill(root){root.querySelectorAll('[data-d]').forEach(function(e){e.innerHTML=dumpling(V[+e.dataset.d])})}
  fill(document);

  /* Cute icons */
  function inner(o){return dumpling(o).replace(/^<svg[^>]*>/,'').replace(/<\/svg>$/,'')}
  function F(x,y,s){s=s||1;var t='#4A363B';return '<circle cx="'+(x-9*s)+'" cy="'+y+'" r="'+(3.2*s)+'" fill="'+t+'"/><circle cx="'+(x+9*s)+'" cy="'+y+'" r="'+(3.2*s)+'" fill="'+t+'"/><ellipse cx="'+(x-15*s)+'" cy="'+(y+6*s)+'" rx="'+(4.5*s)+'" ry="'+(2.8*s)+'" fill="#FF9FAE" opacity=".6"/><ellipse cx="'+(x+15*s)+'" cy="'+(y+6*s)+'" rx="'+(4.5*s)+'" ry="'+(2.8*s)+'" fill="#FF9FAE" opacity=".6"/><path d="M'+(x-4*s)+' '+(y+5*s)+'q'+(4*s)+' '+(4*s)+' '+(8*s)+' 0" fill="none" stroke="'+t+'" stroke-width="'+(2.2*s)+'" stroke-linecap="round"/>'}
  function outl(sh,f,s){return '<g fill="'+s+'" stroke="'+s+'" stroke-width="5" stroke-linejoin="round">'+sh+'</g><g fill="'+f+'">'+sh+'</g>'}
  var cloud='<circle cx="34" cy="60" r="15"/><circle cx="52" cy="46" r="19"/><circle cx="70" cy="58" r="16"/><rect x="30" y="58" width="44" height="18" rx="9"/>';
  var K={
    door:'<rect x="22" y="14" width="56" height="76" rx="14" fill="#FFC2CC" stroke="#E894A2" stroke-width="2.5"/><rect x="31" y="24" width="38" height="56" rx="9" fill="#FFE3E8"/><circle cx="62" cy="70" r="3.4" fill="#F2C063"/>'+F(46,50,.9)+'<path d="M50 3l2.200 5 5.300.5-4 3.500 1.200 5.200L50 14.500 45.300 17.200l1.200-5.200-4-3.500 5.300-.5z" fill="#F2C063"/>',
    dice:'<rect x="18" y="18" width="64" height="64" rx="18" fill="#CFE9F7" stroke="#8DC3DE" stroke-width="2.5"/><g fill="#8DC3DE"><circle cx="33" cy="33" r="4.2"/><circle cx="67" cy="33" r="4.2"/><circle cx="33" cy="67" r="4.2"/><circle cx="67" cy="67" r="4.2"/></g>'+F(50,52,.85),
    cloud:outl(cloud,'#fff','#B9D6EE')+F(52,60,.9),
    gift:'<rect x="20" y="48" width="60" height="38" rx="8" fill="#FFB3C1" stroke="#EE8DA0" stroke-width="2.5"/><rect x="15" y="36" width="70" height="16" rx="7" fill="#FF8FA3" stroke="#EE7188" stroke-width="2.5"/><path d="M50 36C40 12 22 24 36 36z" fill="#F7D488" stroke="#E0A93E" stroke-width="2" stroke-linejoin="round"/><path d="M50 36C60 12 78 24 64 36z" fill="#F7D488" stroke="#E0A93E" stroke-width="2" stroke-linejoin="round"/><circle cx="50" cy="36" r="5.500" fill="#F2C063" stroke="#E0A93E" stroke-width="2"/>'+F(50,68,.85),
    moon:'<circle cx="50" cy="54" r="32" fill="#FFE7A3" stroke="#EBCB7A" stroke-width="2.5"/><circle cx="70" cy="38" r="5" fill="#F7D98C"/><circle cx="32" cy="70" r="4" fill="#F7D98C"/><path d="M34 52q4.500 4.500 9 0M57 52q4.500 4.500 9 0" fill="none" stroke="#4A363B" stroke-width="2.400" stroke-linecap="round"/><ellipse cx="32" cy="60" rx="5" ry="3" fill="#FF9FAE" opacity=".6"/><ellipse cx="68" cy="60" rx="5" ry="3" fill="#FF9FAE" opacity=".6"/><path d="M46 62q4 4 8 0" fill="none" stroke="#4A363B" stroke-width="2.400" stroke-linecap="round"/><path d="M82 8l2 4.500 4.500.5-3.400 3 1 4.500-4.100-2.400-4.100 2.400 1-4.500-3.400-3 4.500-.5z" fill="#F2C063"/>',
    family:'<circle cx="34" cy="52" r="18" fill="#FFC2CC" stroke="#E894A2" stroke-width="2.5"/><circle cx="66" cy="52" r="18" fill="#C9E7D6" stroke="#8FC5A8" stroke-width="2.5"/><circle cx="50" cy="72" r="13" fill="#FFE7A3" stroke="#EBCB7A" stroke-width="2.5"/>'+F(34,52,.62)+F(66,52,.62)+F(50,72,.5)+'<path d="M50 26c-5-7-12-2-8 3l8 7 8-7c4-5-3-10-8-3z" fill="#D0576A"/>',
    squish:'<g transform="translate(0 12) scale(1 .86)">'+inner({c:'#FFE1E6',s:'#EDB4BE'})+'</g><path d="M80 22c-3-5-9-1-6 3l6 5 6-5c3-4-3-8-6-3z" fill="#D0576A"/><path d="M18 30c-2-3-6-.6-4 2l4 3.500 4-3.500c2-2.600-2-5-4-2z" fill="#F2C063"/>',
    star:'<path d="M50 10l12 25 27 4-20 19 5 27-24-13-24 13 5-27-20-19 27-4z" fill="#FFE08A" stroke="#EBB94A" stroke-width="2.5" stroke-linejoin="round"/>'+F(50,56,.8),
    truck:'<rect x="8" y="34" width="54" height="36" rx="9" fill="#FFE7A3" stroke="#EBCB7A" stroke-width="2.5"/><path d="M62 46h13c3 0 5 1.500 7 4l6 8c1 1.500 1.500 3 1.500 4.500V70H62z" fill="#FFCF8A" stroke="#EBAF5F" stroke-width="2.5" stroke-linejoin="round"/><path d="M68 51h8l6 7H68z" fill="#DCEEF9"/><circle cx="27" cy="72" r="9" fill="#8B7479"/><circle cx="27" cy="72" r="3.500" fill="#fff"/><circle cx="72" cy="72" r="9" fill="#8B7479"/><circle cx="72" cy="72" r="3.500" fill="#fff"/>'+F(35,52,.85),
    lock:'<path d="M34 46V34a16 16 0 0 1 32 0v12" fill="none" stroke="#B3A5DE" stroke-width="7" stroke-linecap="round"/><rect x="22" y="44" width="56" height="42" rx="13" fill="#D9D0F2" stroke="#B3A5DE" stroke-width="2.5"/>'+F(50,64,.9),
    box:'<rect x="16" y="36" width="68" height="48" rx="10" fill="#FFD9B8" stroke="#EBAA7D" stroke-width="2.5"/><rect x="42" y="36" width="16" height="20" fill="#F4B98A"/>'+F(50,68,.85)+'<circle cx="76" cy="26" r="13" fill="#fff" stroke="#EDB4BE" stroke-width="2.5"/><path d="M82 26a6 6 0 1 1-2-4.500" fill="none" stroke="#D0576A" stroke-width="3" stroke-linecap="round"/><path d="M82 17v6h-6" fill="none" stroke="#D0576A" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>',
    mail:'<rect x="12" y="26" width="76" height="52" rx="12" fill="#FFE1E6" stroke="#EDB4BE" stroke-width="2.5"/><path d="M16 34l34 24 34-24" fill="none" stroke="#EDB4BE" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M50 78c-8-7-13-10-13-15 0-5 6-6 9-2l4 4 4-4c3-4 9-3 9 2 0 5-5 8-13 15z" fill="#D0576A" transform="translate(0 -8)"/>',
    tree:'<rect x="44" y="82" width="12" height="9" rx="2" fill="#C9A183"/><path d="M50 44L86 84H14z" fill="#7FC4A0" stroke="#5E9C82" stroke-width="2.5" stroke-linejoin="round"/><path d="M50 26L80 62H20z" fill="#8FD0AC" stroke="#5E9C82" stroke-width="2.5" stroke-linejoin="round"/><path d="M50 12L74 42H26z" fill="#9BD9B7" stroke="#5E9C82" stroke-width="2.5" stroke-linejoin="round"/>'+F(50,70,.8)+'<circle cx="30" cy="78" r="3" fill="#D0576A"/><circle cx="70" cy="76" r="3" fill="#F2C063"/><path d="M50 0l2 4.500 4.500.5-3.400 3 1 4.500-4.100-2.400-4.100 2.400 1-4.500-3.400-3 4.500-.5z" fill="#F2C063"/>'
  };
    document.querySelectorAll('[data-k]').forEach(function(e){e.innerHTML='<svg viewBox="0 0 100 100" aria-hidden="true">'+K[e.dataset.k]+'</svg>'});

  /* Illustration: basket full of dumplings */
  function scene(){
    function d(i,x,y,w){return '<svg x="'+x+'" y="'+y+'" width="'+w+'" height="'+w+'" viewBox="0 0 100 100">'+dumpling(V[i]).replace(/^<svg[^>]*>/,'').replace(/<\/svg>$/,'')+'</svg>'}
    var s='<svg class="scene" viewBox="0 0 340 260" role="img" aria-label="Bamboo basket full of Christmas dumplings">';
    s+='<g fill="#fff" opacity=".9"><circle cx="30" cy="40" r="4"/><circle cx="300" cy="60" r="5"/><circle cx="58" cy="120" r="3"/><circle cx="286" cy="130" r="3.5"/><circle cx="170" cy="14" r="3"/></g>';
    s+='<g fill="#F2C063"><path d="M42 74c.5 4 2 5.500 6 6-4 .5-5.500 2-6 6-.5-4-2-5.500-6-6 4-.5 5.500-2 6-6z"/><path d="M298 92c.4 3 1.500 4.200 4.500 4.500-3 .4-4.100 1.500-4.500 4.500-.4-3-1.500-4.100-4.500-4.500 3-.3 4.100-1.500 4.500-4.500z"/></g>';
    s+='<g fill="none" stroke="#F3CBD2" stroke-width="4" stroke-linecap="round"><path d="M120 62q-9-12 0-24t0-22"/><path d="M172 46q-9-12 0-24t0-16"/><path d="M224 62q-9-12 0-24t0-22"/></g>';
    s+=d(0,40,74,100)+d(1,120,58,108)+d(8,206,74,100);
    s+='<path d="M36 156h268l-22 70a14 14 0 0 1-13 10H71a14 14 0 0 1-13-10z" fill="#EBCB9A"/>';
    s+='<g stroke="#D8B27A" stroke-width="3" stroke-linecap="round"><path d="M50 184h240M56 208h228M110 158l-7 74M170 158v78M230 158l7 74"/></g>';
    s+='<rect x="26" y="144" width="288" height="22" rx="11" fill="#F3DBB1" stroke="#D8B27A" stroke-width="2.5"/>';
    s+='<path d="M170 176l-20-12v24zM170 176l20-12v24z" fill="#D0576A"/><circle cx="170" cy="176" r="6" fill="#B7465A"/>';
    return s+'</svg>';
  }
  
  var sb=$('sceneBox'); if(sb)sb.innerHTML=scene();

  /* ---------- helpers ---------- */
  var nf=new Intl.NumberFormat(T.locale||'en',{style:'currency',currency:T.currency||'EUR'});
  function money(c){return nf.format(c/100)}
  function esc(s){return String(s==null?'':s).replace(/[&<>"']/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})}
  function ic(n){return '<svg class="ic"><use href="#i-'+n+'"/></svg>'}
  var toast=$('toast'),tt;
  function say(t){if(!toast)return;toast.textContent=t;toast.classList.add('show');clearTimeout(tt);tt=setTimeout(function(){toast.classList.remove('show')},2800)}
  function sized(url,w){if(!url)return '';return url+(url.indexOf('?')>-1?'&':'?')+'width='+w}

  /* ---------- Cart drawer ---------- */
  var drawer=$('drawer'),scrim=$('scrim'),body=$('cartBody'),foot=$('cartFoot'),lastFocus;
  function setCount(n){var b=$('cartCount');if(b)b.textContent=n}
  function fetchCart(){return fetch(T.routes.cart,{headers:{'Accept':'application/json'}}).then(function(r){return r.json()})}
  function render(c){
    setCount(c.item_count);
    if(!drawer)return;
    if(!c.item_count){
      body.innerHTML='<div class="empty-cart"><div class="dump">'+dumpling(V[0])+'</div><h4>Your cart is empty</h4><p>A little dumpling is already waiting to move in with you.</p><button class="ghost" type="button" data-act="keep">Continue shopping</button></div>';
      foot.style.display='none';return;
    }
    foot.style.display='';
    var t=c.total_price/100,free=t>=(T.freeShipping||0),sh=free?0:(T.shippingFee||0);
    var ship='<div class="ship"><p>'+(free?ic('check')+'Free shipping unlocked':ic('truck')+'Only '+nf.format((T.freeShipping||0)-t)+' left until free shipping')+'</p><div class="trk"><i style="width:'+Math.min(100,t/(T.freeShipping||1)*100)+'%"></i></div></div>';
    var items=c.items.map(function(it){
      var img=it.image?'<img src="'+esc(sized(it.image,180))+'" alt="'+esc(it.product_title)+'">':'<span class="dump">'+dumpling(V[0])+'</span>';
      var v=it.variant_title&&it.variant_title!=='Default Title'?'<p>'+esc(it.variant_title)+'</p>':'';
      return '<div class="item">'+img+'<div><h4>'+esc(it.product_title)+'</h4>'+v+'<div class="irow"><div class="mini"><button type="button" data-act="dec" data-key="'+esc(it.key)+'" data-qty="'+it.quantity+'" aria-label="Decrease quantity">'+ic('minus')+'</button><output>'+it.quantity+'</output><button type="button" data-act="inc" data-key="'+esc(it.key)+'" data-qty="'+it.quantity+'" aria-label="Increase quantity">'+ic('plus')+'</button></div><span class="iprice">'+money(it.final_line_price)+'</span></div><button class="rm" type="button" data-act="rm" data-key="'+esc(it.key)+'" data-qty="'+it.quantity+'">'+ic('trash')+'Remove</button></div></div>';
    }).join('');
    body.innerHTML=ship+items;
    var disc=c.original_total_price-c.total_price;
    $('subVal').textContent=money(c.original_total_price);
    $('discRow').style.display=disc>0?'':'none';
    $('discVal').textContent='−'+money(disc);
    $('shipVal').textContent=free?'Free':nf.format(sh);
    $('shipRow').classList.toggle('free',free);
    $('sumVal').textContent=money(c.total_price+sh*100);
  }
  function openDrawer(){
    if(!drawer)return;
    lastFocus=document.activeElement;
    drawer.classList.add('on');scrim.classList.add('on');drawer.setAttribute('aria-hidden','false');
    document.body.style.overflow='hidden';
    var s=$('sticky');if(s)s.classList.remove('show');
    setTimeout(function(){var x=$('closeCart');if(x)x.focus()},60);
  }
  function closeDrawer(){
    if(!drawer)return;
    drawer.classList.remove('on');scrim.classList.remove('on');drawer.setAttribute('aria-hidden','true');
    document.body.style.overflow='';
    if(lastFocus&&lastFocus.focus)lastFocus.focus();
    checkSticky();
  }
  function change(key,q){
    return fetch(T.routes.cartChange,{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity:q})})
      .then(function(r){return r.json()}).then(render);
  }
  var openBtn=$('openCart');
  if(openBtn)openBtn.addEventListener('click',function(e){
    if(!drawer)return;
    e.preventDefault();
    fetchCart().then(function(c){render(c);openDrawer()}).catch(function(){window.location.href=T.routes.cartPage||'/cart'});
  });
  if(drawer){
    $('closeCart').onclick=closeDrawer;scrim.onclick=closeDrawer;
    var kp=$('keep');if(kp)kp.onclick=closeDrawer;
    document.addEventListener('keydown',function(e){
      if(!drawer.classList.contains('on'))return;
      if(e.key==='Escape')closeDrawer();
      if(e.key==='Tab'){
        var f=Array.prototype.filter.call(drawer.querySelectorAll('button,a[href]'),function(n){return n.offsetParent!==null}),a=f[0],z=f[f.length-1];
        if(!a)return;
        if(e.shiftKey&&document.activeElement===a){e.preventDefault();z.focus()}
        else if(!e.shiftKey&&document.activeElement===z){e.preventDefault();a.focus()}
      }
    });
    body.addEventListener('click',function(e){
      var b=e.target.closest('[data-act]');if(!b)return;
      var a=b.dataset.act;
      if(a==='keep'){closeDrawer();return}
      var q=+b.dataset.qty;
      if(a==='inc')q+=1;else if(a==='dec')q=Math.max(0,q-1);else if(a==='rm')q=0;
      change(b.dataset.key,q);
    });
  }

  /* ---------- Add to cart ---------- */
  var pf=$('product-form');
  function addToCart(){
    if(!pf)return;
    var btn=$('add');if(btn)btn.disabled=true;
    fetch(T.routes.cartAdd,{method:'POST',body:new FormData(pf),headers:{'Accept':'application/json'}})
      .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j}})})
      .then(function(res){
        if(btn)btn.disabled=false;
        if(!res.ok){say(res.j.description||res.j.message||'Sorry, this item could not be added to your cart.');return}
        window.location.assign((window.Shopify.routes.root || '/') + 'checkout');
      })
      .catch(function(){if(btn)btn.disabled=false;pf.submit()});
  }
  if(pf){
    pf.addEventListener('submit',function(e){e.preventDefault();addToCart()});
    var sa=$('stAdd');if(sa)sa.addEventListener('click',addToCart);
    var bl=pf.querySelector('.bundles');
    if(bl)bl.addEventListener('change',function(){
      Array.prototype.forEach.call(bl.children,function(c){var i=c.querySelector('input');c.classList.toggle('on',!!(i&&i.checked))});
      var chk=bl.querySelector('input:checked');
      if(chk&&chk.dataset.money){var ap=$('addPrice'),sp=$('stPrice');if(ap)ap.textContent=chk.dataset.money;if(sp)sp.textContent=chk.dataset.money}
    });
  }
  var td=$('toDeal');
  if(td)td.onclick=function(){var t=$('bundles')||$('add');if(t)t.scrollIntoView({behavior:'smooth',block:'center'})};
  var tt2=$('toTop');
  if(tt2)tt2.onclick=function(){window.scrollTo({top:0})};

  /* ---------- Sticky buy bar (mobile) ---------- */
  var st=$('sticky'),addBtn=$('add');
  function checkSticky(){
    if(!st||!addBtn)return;
    var r=addBtn.getBoundingClientRect();
    st.classList.toggle('show',r.bottom<0&&!(drawer&&drawer.classList.contains('on')));
  }
  if(st&&addBtn){window.addEventListener('scroll',checkSticky,{passive:true});window.addEventListener('resize',checkSticky);checkSticky()}

  /* ---------- Gallery ---------- */
  var slides=[].slice.call(document.querySelectorAll('.slide')),thumbs=[].slice.call(document.querySelectorAll('#thumbs .thumb')),gi=0;
  function show(n){
    if(!slides.length)return;
    gi=(n+slides.length)%slides.length;
    slides.forEach(function(s,i){s.classList.toggle('on',i===gi)});
    thumbs.forEach(function(t,i){t.classList.toggle('active',i===gi)});
    var gc=$('gCount');if(gc)gc.textContent=(gi+1)+' / '+slides.length;
  }
  var gp=$('gPrev'),gn=$('gNext');
  if(gp)gp.onclick=function(){show(gi-1)};
  if(gn)gn.onclick=function(){show(gi+1)};
  thumbs.forEach(function(t,i){t.onclick=function(){show(i)}});
  var sl=$('slides');
  if(sl&&slides.length>1){
    var sx=null;
    sl.addEventListener('touchstart',function(e){sx=e.touches[0].clientX},{passive:true});
    sl.addEventListener('touchend',function(e){if(sx===null)return;var dx=e.changedTouches[0].clientX-sx;if(Math.abs(dx)>40)show(gi+(dx<0?1:-1));sx=null});
  }

  /* ---------- Door game ---------- */
  var game=$('game');
  if(game){
    for(var i=1;i<=24;i++){
      var b=document.createElement('button');
      b.type='button';b.className='door';b.textContent=i;b.dataset.n=i;b.setAttribute('aria-label','Open door '+i);
      b.onclick=function(){
        if(this.classList.contains('open'))return;
        this.classList.add('open');
        this.innerHTML='<span class="dump">'+dumpling(V[Math.floor(Math.random()*V.length)])+'</span>';
        this.setAttribute('aria-label','Door '+this.dataset.n+' opened');
      };
      game.appendChild(b);
    }
    var rs=$('reset');
    if(rs)rs.onclick=function(){
      var d=game.children;
      for(var i=0;i<d.length;i++){d[i].classList.remove('open');d[i].textContent=i+1;d[i].setAttribute('aria-label','Open door '+(i+1))}
    };
  }

  /* ---------- Countdown ---------- */
  var cw=$('cdWrap');
  if(cw){
    var month=(+cw.dataset.month||12)-1,day=+cw.dataset.day||1;
    var tick=function(){
      var now=new Date(),t=new Date(now.getFullYear(),month,day,0,0,0);
      if(now>=t){$('cdText').textContent=cw.dataset.started||'';$('cd').style.display='none';return}
      var diff=t-now;
      $('cdD').textContent=Math.floor(diff/864e5);
      $('cdH').textContent=Math.floor(diff%864e5/36e5);
      $('cdM').textContent=Math.floor(diff%36e5/6e4);
    };
    tick();setInterval(tick,30000);
  }
})();
